import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';

import {
  getNotificationStatus,
  getNotificationType,
  getNotificationData,
} from 'js/store/notification/notification.selectors';
import { notificationPrompt } from 'js/store/notification/notification.actions';
import { getTranslationById } from 'js/store/app/App.selectors';

let timer = null;
const transition = { duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] };

const Notification = () => {
  const dispatch = useDispatch();
  const prevValue = useRef();
  const [showPrompt, updateShowPrompt] = useState(false);
  const [currentPrompt, updateCurrentPrompt] = useState('');

  const prompt = useSelector((state) => {
    return {
      active: getNotificationStatus(state),
      type: getNotificationType(state),
      data: getNotificationData(state),
    };
  });

  const dispatchToggle = () => {
    updateShowPrompt(false);
    setTimeout(() => {
      dispatch(notificationPrompt({ type: false, additionalData: false }));
    }, 600);
  };

  const setTimer = () => {
    timer = setTimeout(dispatchToggle, 3000);
  };

  const siteText = {
    CREATE_COLLECTION: useSelector((state) =>
      getTranslationById(state, 'notification_create_collection', 'Collection created')
    ),
    DELETE_COLLECTION: useSelector((state) =>
      getTranslationById(state, 'notification_delete_collection', 'Collection deleted:')
    ),
    UPDATE_COLLECTION: useSelector((state) =>
      getTranslationById(state, 'notification_update_collection', 'Collection updated')
    ),
    REMOVE_CARD_FROM_COLLECTION: useSelector((state) =>
      getTranslationById(state, 'notification_remove_card_collection', 'Card removed from collection:')
    ),
    ADD_CARD_TO_COLLECTION: useSelector((state) =>
      getTranslationById(state, 'notification_add_card_collection', 'Card added to collection:')
    ),
    FAVORITE_REMOVED: useSelector((state) =>
      getTranslationById(state, 'notification_favorite_removed', 'Favorite removed')
    ),
    FAVORITE_ADDED: useSelector((state) => getTranslationById(state, 'notification_favorite_added', 'Favorite added')),
    QR_CODE_SAVED: useSelector((state) => getTranslationById(state, 'notification_qr_saved', 'QR saved')),
    LINK_COPIED: useSelector((state) => getTranslationById(state, 'notification_link_copied', 'Link copied')),
  };

  useEffect(() => {
    if (showPrompt) {
      return;
    }

    prevValue.current = prompt.type;
    updateCurrentPrompt(prompt);

    updateShowPrompt(prompt.active);
    prompt.active && setTimer();
  }, [prompt.active, prompt.type, prompt.data]);

  return (
    <AnimatePresence>
      {showPrompt && (
        <motion.div
          initial={{ y: -100, x: '-50%' }}
          animate={{ y: 40, x: '-50%', transition }}
          exit={{ y: -100, x: '-50%', transition }}
          key={'notification'}
          className={'notification'}
        >
          <div className="notification__body">{`${siteText[currentPrompt.type]} ${
            currentPrompt.data?.additionalData?.name || ''
          }`}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Notification;
